import { createNames } from "../../utils";
export const getAceHeroSliderNames = (id) => {
    return createNames(id, 'ACE-HERO-SLIDER', 'CONTAINER', 'SLIDE', 'SLIDE____CURRENT', '_WIDTH');
};
export const aceHeroSliderCssVariables = {
    WIDTH: '--ace-hero-slider-width',
    BACKGROUND_COLOR: '--ace-hero-slider-background-color',
};
//# sourceMappingURL=ace-hero-slider.get-names.js.map
